export const isSsr = (): boolean => typeof window === "undefined"
